var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2 mt-md-5 mb-5"},[_c('MainWorksSectionHeader',{attrs:{"year":_vm.year}}),_c('div',{staticClass:"projects-container d-flex flex-wrap justify-content-left"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }